import React, { SVGProps } from 'react';

const ChargerIcon = ({
  className,
  fill = '#fff',
  width = 15,
  height = 15,
  style,
}: SVGProps<SVGSVGElement>) => (
  <span className={className} style={style}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill={fill}
    >
      <path
        d="M12.8033 2.34046C11.3867 0.8312 9.5033 0 7.49998 0C5.49667 0 3.61326 0.8312 2.19671 2.34046C0.780137 3.84976 0 5.85642 0 7.99089C0 9.41632 0.356815 10.8159 1.03185 12.0381C1.68671 13.2238 2.62304 14.2155 3.73966 14.9062C3.84243 14.9697 3.95472 15 4.06559 15C4.28981 15 4.50801 14.8763 4.62869 14.6547C4.80901 14.3238 4.70339 13.8997 4.39271 13.7076C2.48553 12.5281 1.30076 10.3376 1.30076 7.99086C1.30076 4.34888 4.08171 1.3859 7.49995 1.3859C10.9182 1.3859 13.6991 4.34888 13.6991 7.99086C13.6991 9.53034 13.3079 10.8146 12.5676 11.7047C11.9651 12.4293 11.1562 12.8448 10.3484 12.8448C9.53882 12.8448 8.62152 12.391 8.28426 11.1891C9.58907 10.902 10.573 9.66826 10.573 8.19433V6.17501C10.573 6.07938 10.5002 6.00179 10.4105 6.00179H9.54053V4.11126C9.54053 3.72857 9.24938 3.41833 8.8902 3.41833C8.53096 3.41833 8.23978 3.72857 8.23978 4.11126V6.00179H6.76029V4.11126C6.76029 3.72857 6.4691 3.41833 6.10989 3.41833C5.75068 3.41833 5.45953 3.72857 5.45953 4.11126V6.00179H4.58958C4.49979 6.00179 4.427 6.07938 4.427 6.17501V8.19433C4.427 9.75672 5.53255 11.049 6.95385 11.2302C7.10658 11.9946 7.42532 12.6517 7.89734 13.1646C8.53005 13.852 9.40059 14.2306 10.3485 14.2306C11.5283 14.2306 12.692 13.6449 13.5412 12.6238C14.2067 11.8236 15 10.3702 15 7.99079C14.9999 5.85642 14.2198 3.84973 12.8033 2.34046Z"
        fill={fill}
      />
    </svg>
  </span>
);

export default ChargerIcon;
